// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*As per SAP UX Standards, In entire application there should not be bold text. So, commenting this font Styles*/
.cald_report-tag-container .cald_report-tag-content .cald_report-tag-content-existing-header, .cald_report-tag-container .cald_report-tag-header-lbl {
  font-family: "72-Regular";
}

.cc_reports-list-container .cald_reports-tag-tab-container {
  padding: 1.6rem;
}
.cc_reports-list-container .cald_reports-tag-tab-container .cc-tag-option {
  cursor: pointer;
}
.cc_reports-list-container .cald_reports-tag-tab-container .selTagTab {
  background-color: #2797df;
}

.cald_tag-input {
  font-size: 14px;
}
.cald_tag-input .ng2-tag-input__text-input {
  width: 25rem;
}

.ng2-tag-input.ng2-tag-input {
  border-radius: 0.4rem;
  border: solid 0.1rem #ceced0;
  height: auto;
  padding: 0.4rem 0.4rem;
  overflow: auto;
}
.ng2-tag-input.ng2-tag-input .ng2-tag-input__text-input {
  height: 2.1rem;
}
.ng2-tag-input.ng2-tag-input tag {
  border-radius: 0.2rem;
  background-color: #eef5fc;
  padding: 0.2rem 0.4rem;
  font-size: 1.2rem;
  color: #515559;
  margin-right: 0.4rem;
  text-transform: capitalize;
  height: auto;
  line-height: normal;
}
.ng2-tag-input.ng2-tag-input tag delete-icon span {
  border: 0.1rem solid #0a6ed1;
  border-radius: 50%;
}
.ng2-tag-input.ng2-tag-input tag delete-icon svg {
  height: 1.8rem;
  width: 1.2rem;
  vertical-align: middle;
}
.ng2-tag-input.ng2-tag-input tag delete-icon svg path {
  fill: #0a6ed1;
}
.ng2-tag-input.ng2-tag-input tag delete-icon:hover {
  transform: none !important;
}
.ng2-tag-input.ng2-tag-input tag:hover {
  background-color: #eef5fc !important;
}

.cald_table [class^=icon]:before {
  font-size: 1.4rem !important;
}
.cald_table .link-btn {
  text-align: left !important;
  cursor: pointer;
}

.cald_report-tag-container {
  width: 35rem;
}
.cald_report-tag-container .cald_report-tag-header-lbl {
  font-size: 1.2rem;
  color: #6a6d70;
  display: inline-block;
  margin-bottom: 0.5rem;
}
.cald_report-tag-container .cald_report-tag-content {
  width: 100%;
  padding: 1.6rem;
}
.cald_report-tag-container .cald_report-tag-content .cald_report-tag-content-existing-header {
  font-size: 1.2rem;
  color: #4a4a4a;
  margin: 1rem 0rem;
}
.cald_report-tag-container .cald_report-tag-footer {
  width: 100%;
  padding: 0.7rem 1.6rem;
}

.dropdown-menu {
  top: 16px !important;
  right: -32px !important;
}

.searchByReportNameSearchIcon {
  position: relative;
  top: -2.5rem;
  left: 16rem;
}

.searchByAuthorNameSearchIcon {
  position: relative;
  top: -2.5rem;
  left: 10.7rem;
}`, "",{"version":3,"sources":["webpack://./src/app/assets/css/fonts.scss","webpack://./src/app/shared/report-tags/report-tags.component.scss"],"names":[],"mappings":"AAIA,gHAAA;AAqBA;EACI,yBAAA;ACvBJ;;AADE;EACE,eAAA;AAIJ;AAHI;EACE,eAAA;AAKN;AAHI;EACE,yBAAA;AAKN;;AAAA;EACE,eAAA;AAGF;AAFE;EACI,YAAA;AAIN;;AADA;EACE,qBAAA;EACA,4BAAA;EACA,YAAA;EACA,sBAAA;EACA,cAAA;AAIF;AAHE;EACE,cAAA;AAKJ;AAHE;EACE,qBAAA;EACA,yBAAA;EACA,sBAAA;EACA,iBAAA;EACA,cAAA;EACA,oBAAA;EACA,0BAAA;EACA,YAAA;EACA,mBAAA;AAKJ;AAHM;EACE,4BAAA;EACA,kBAAA;AAKR;AAHM;EACE,cAAA;EACA,aAAA;EACA,sBAAA;AAKR;AAJQ;EACE,aAAA;AAMV;AAHM;EACE,0BAAA;AAKR;AAFI;EACE,oCAAA;AAIN;;AACE;EACE,4BAAA;AAEJ;AAAE;EACE,2BAAA;EACA,eAAA;AAEJ;;AACA;EACI,YAAA;AAEJ;AADI;EAEE,iBAAA;EACA,cAAA;EACA,qBAAA;EACA,qBAAA;AAEN;AAAI;EACE,WAAA;EACA,eAAA;AAEN;AADM;EAEE,iBAAA;EACA,cAAA;EACA,iBAAA;AAER;AACI;EACE,WAAA;EACA,sBAAA;AACN;;AAEA;EACE,oBAAA;EACA,uBAAA;AACF;;AAEA;EACE,kBAAA;EACA,YAAA;EACA,WAAA;AACF;;AAEA;EACE,kBAAA;EACA,YAAA;EACA,aAAA;AACF","sourcesContent":["%font-black{\n    font-family: '72-Black';\n}\n\n/*As per SAP UX Standards, In entire application there should not be bold text. So, commenting this font Styles*/\n// %font-bold{\n//     font-family: '72-Bold';\n// }\n\n// %font-condensed-bold{\n//     font-family: '72-CondensedBold';\n// }\n\n// %font-bold-italic{\n//     font-family: '72-BoldItalic';\n// }\n\n%font-condensed{\n    font-family: '72-Condensed';\n}\n\n%font-italic{\n    font-family: '72-Italic';\n}\n\n%font-regular{\n    font-family: '72-Regular';\n}\n\n%font-light{\n    font-family: '72-Light';\n}\n\n@import '_variables';","@import '../../assets/css/fonts';\n.cc_reports-list-container {\n  .cald_reports-tag-tab-container{\n    padding: 1.6rem;\n    .cc-tag-option{\n      cursor: pointer;\n    }\n    .selTagTab{\n      background-color: #2797df;\n    }\n  }\n  \n}\n.cald_tag-input{\n  font-size: 14px;\n  .ng2-tag-input__text-input{\n      width: 25rem;\n    }\n}\n.ng2-tag-input.ng2-tag-input{\n  border-radius: 0.4rem;\n  border: solid 0.1rem #ceced0;\n  height: auto;\n  padding: 0.4rem 0.4rem;\n  overflow: auto;\n  .ng2-tag-input__text-input{\n    height: 2.1rem;\n  }\n  tag{\n    border-radius: 0.2rem;\n    background-color: #eef5fc;\n    padding: 0.2rem 0.4rem;\n    font-size: 1.2rem;\n    color: #515559;\n    margin-right: 0.4rem;\n    text-transform: capitalize;\n    height: auto;\n    line-height: normal;\n    delete-icon{ \n      span{\n        border: 0.1rem solid #0a6ed1;\n        border-radius: 50%;\n      }\n      svg{\n        height: 1.8rem;\n        width: 1.2rem;\n        vertical-align: middle;\n        path{\n          fill: #0a6ed1;\n        }\n      }\n      &:hover{\n        transform: none !important;\n      }\n    }\n    &:hover{\n      background-color: #eef5fc !important;\n    }\n  }\n}\n.cald_table{\n  [class^=\"icon\"]:before{\n    font-size: 1.4rem !important;\n  }\n  .link-btn{\n    text-align: left !important;\n    cursor: pointer;\n  }\n}\n.cald_report-tag-container{\n    width: 35rem;\n    .cald_report-tag-header-lbl{\n      @extend %font-regular;\n      font-size: 1.2rem;\n      color: #6a6d70;\n      display: inline-block;\n      margin-bottom: 0.5rem;\n    }\n    .cald_report-tag-content{\n      width: 100%;\n      padding: 1.6rem;\n      .cald_report-tag-content-existing-header{\n        @extend %font-regular;\n        font-size: 1.2rem;\n        color: #4a4a4a;\n        margin: 1rem 0rem;\n      }\n    }\n    .cald_report-tag-footer{\n      width: 100%;\n      padding: 0.7rem 1.6rem;\n    }\n}\n.dropdown-menu {\n  top: 16px !important;\n  right: -32px !important;\n}\n\n.searchByReportNameSearchIcon{\n  position: relative;\n  top: -2.5rem;\n  left: 16rem;\n}\n\n.searchByAuthorNameSearchIcon{\n  position: relative;\n  top: -2.5rem;\n  left: 10.7rem;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
